import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Button } from 'react-bootstrap';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import Authorize from '@awp/components/Authorize';
import { FORM_MODE } from '@awp/constants';
import AwpCloseCancelButtons from '../../components/AwpCloseCancelButton';

const AwpFormActionButtons = ({
  title,
  mode,
  onClickCancel,
  permissions,
  showDeleteBtn = true,
  showEditBtn = true,
  showCancelBtn = true,
  showEditBtnOnly = false,
  readOnly = false,
  btnCancelName = 'Cancel',
  isAlignLeft = false,
  disableSave = false,
  entityName,
  setMode,
  onClickDelete,
  onClickEdit,
  onClickSave,
  isPristine = true,
  props,
}) => {
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [hideAuxBtn, setHideAuxBtn] = useState(false);

  const handleEdit = () => {
    if (onClickEdit) {
      onClickEdit();
      return;
    }
    setMode(FORM_MODE.EDIT);
  };

  const handleCancel = () => {
    if (onClickCancel) {
      onClickCancel();
      return;
    }
    props.resetForm();
    setMode(FORM_MODE.LIST);
  };

  const handleSave = () => {
    if (onClickSave) {
      onClickSave();
      return;
    }
    props.submitForm();
  };

  return isAlignLeft ? (
    <>
      {!readOnly ? (
        <Col sm={12} className="pr-micro-0">
          {!showEditBtnOnly && (
            <div className="d-flex align-items-center">
              <AwpCloseCancelButtons
                props={props}
                isPristine={isPristine || props.isSubmitting}
                hasAccess={true}
                wrapperClass={'mr-3 mr-micro-0 mr-md-0'}
                onSaveSuccess={() => {
                  handleSave();
                }}
                onCancel={(result) => {
                  setHideAuxBtn(result);
                }}
                onConfirmedCancel={() => {
                  handleCancel();
                }}
                disableSave={disableSave}
              />
              {!showCancelConfirm && mode !== FORM_MODE.CREATE && !hideAuxBtn && showDeleteBtn && (
                <Button
                  className="ml-4"
                  variant="danger"
                  disabled={!props.isValid || props.isSubmitting}
                  onClick={() => {
                    onClickDelete();
                  }}
                >
                  Delete
                </Button>
              )}
            </div>
          )}
        </Col>
      ) : (
        <Col sm={12} md={6} className="pr-0">
          {' '}
          <div className="mr-3 mr-mini-0">
            {showCancelBtn && (
              <Button
                className="mr-2"
                variant="outline-primary"
                onClick={() => {
                  handleCancel();
                }}
              >
                {btnCancelName}
              </Button>
            )}
            <Authorize requires={permissions}>
              {showEditBtn && (
                <Button className="mr-2 mr-mini-0" variant="outline-primary" onClick={handleEdit}>
                  {`Edit ${isValueEmpty(entityName) ? '' : entityName}`}
                </Button>
              )}
            </Authorize>
          </div>
        </Col>
      )}
      <Col sm={12} md={6} lg={5}>
        <h2>{title}</h2>
      </Col>
    </>
  ) : (
    <>
      <Col sm={12} md={6} lg={5}>
        <h2>{title}</h2>
      </Col>
      {!readOnly ? (
        <Col sm={12} md={6} lg={7} className="pr-micro-0">
          {!showEditBtnOnly && (
            <div className="d-flex align-items-center">
              <AwpCloseCancelButtons
                props={props}
                isPristine={isPristine || props.isSubmitting}
                hasAccess={true}
                onSaveSuccess={() => {
                  props.submitForm();
                }}
                onConfirmedCancel={() => {
                  handleCancel();
                }}
                onCancel={(result) => {
                  setHideAuxBtn(result);
                }}
                disableSave={disableSave}
              />
              {!showCancelConfirm && mode !== FORM_MODE.CREATE && !hideAuxBtn && showDeleteBtn && (
                <Button
                  className="mt-4 ml-3"
                  variant="danger"
                  disabled={!props.isValid || props.isSubmitting}
                  onClick={() => {
                    onClickDelete();
                  }}
                >
                  Delete
                </Button>
              )}
            </div>
          )}
        </Col>
      ) : (
        <Col sm={12} md={6} className="pr-0">
          {' '}
          <div className="mr-3 mr-mini-0" style={{ float: 'right' }}>
            {showCancelBtn && (
              <Button
                className="mr-2"
                variant="outline-primary"
                onClick={() => {
                  handleCancel();
                }}
              >
                {btnCancelName}
              </Button>
            )}
            <Authorize requires={permissions}>
              {showEditBtn && (
                <Button className="mr-2 mr-mini-0" variant="outline-primary" onClick={handleEdit}>
                  {`Edit ${isValueEmpty(entityName) ? '' : entityName}`}
                </Button>
              )}
            </Authorize>
          </div>
        </Col>
      )}
    </>
  );
};

AwpFormActionButtons.propTypes = {
  title: PropTypes.any,
  entityName: PropTypes.any,
  mode: PropTypes.any,
  setMode: PropTypes.any,
  permissions: PropTypes.any,
  onClickDelete: PropTypes.any,
  onClickCancel: PropTypes.any,
  onClickEdit: PropTypes.any,
};

export default AwpFormActionButtons;
